import React from "react";
import "./App.css";
import profile from "./3d_avatar.webp";
import TCSlogo from "./TCS.png";
import AnnaUnivLogo from "./Anna_Univ.png";
import Header from "./Header";
function getYearsOfExperience(startDate, endDate = new Date()) {
  const start = startDate.getFullYear() * 12 + startDate.getMonth();
  const end = endDate.getFullYear() * 12 + endDate.getMonth();
  const monthInterval = end - start;
  const yearsOfExperience = Math.floor(monthInterval / 12);
  const monthsOfExperience = monthInterval % 12;

  return `${yearsOfExperience}.${monthsOfExperience}`;
}
const App = () => {
  return (
    <>
      <main className="text-white mx-auto bg-black h-auto">
        <section id="home">
          <Header />

          {/* Hero Start */}
          <section className="hero text-center p-10">
            <h1 className="text-4xl lg:text-5xl text-teal-500 mb-4 font-medium mx-auto">
              Nabeel G M
            </h1>
            <h3 className=" text-xl pt-1 pb-3 font-semibold">
              Full Stack Developer
            </h3>
            <p className="mx-auto text-base py-2 leading-7 text-gray-50 max-w-2xl lg:max-w-xl ">
              <span className="font-semibold">Full Stack Developer </span>with{" "}
              {getYearsOfExperience(new Date("26 August 2021"))} years of
              experience in development of Interactive, Responsive, & Reactive
              websites built using modern Frameworks and Libraries
            </p>
            <p className="text-teal-500"></p>
          </section>
          <section className="flex justify-center gap-16">
            <button
              title="Nabeel's Github"
              className="fa fa-github text-4xl"
              onClick={() => window.open("https://www.github.com/gmnabeel/")}
            ></button>
            <button
              title="Nabeel's Linkedin"
              className="fa fa-linkedin text-3xl"
              onClick={() =>
                window.open("https://www.linkedin.com/in/gmnabeel/")
              }
            ></button>
            <button
              title="Nabeel's Stackoverflow"
              className="fa fa-brands fa-stack-overflow text-3xl"
              onClick={() =>
                window.open(
                  "https://stackoverflow.com/users/10522121/nabeel-gm/"
                )
              }
            ></button>
          </section>
          <section className="flex justify-center my-10">
            <img
              src={profile}
              alt="Nabeel Avatar"
              width="200px"
              height="150px"
              className=" bg-gradient-to-b from-teal-600 rounded-full h-75 w-75"
            />
          </section>
        </section>

        {/* Skills */}
        <section id="skills" className="w-5/6 mx-auto mb-14">
          <h2 className=" text-3xl text-teal-500 font-normal my-5 block">
            Skills
          </h2>
          <ul className="w-5/6 mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 text-center [&>*]:border-2 [&>*]:rounded-lg [&>*]:py-2 [&>*]:px-1 gap-x-10 gap-y-6">
            <li>HTML</li>
            <li>CSS</li>
            <li>Javascript</li>

            <li>React</li>
            <li>Redux</li>
            <li>React Router</li>

            <li>AWS</li>
            <li>My SQL</li>
            <li>Python</li>

            <li>Material UI</li>
            <li>Tailwind CSS</li>
            <li>Bootstrap</li>
          </ul>
        </section>

        {/* Experience */}
        <section id="experience" className="w-5/6 mx-auto mb-14">
          <h2 className=" text-3xl text-teal-500 font-normal my-5 block">
            Experience
          </h2>
          <section
            className="w-5/6 mx-auto"
            onClick={() => window.open("https://www.tcs.com")}
          >
            <div className="bg-slate-100 lg:w-1/3 md:w-2/3 px-10 py-4 rounded-lg hover:bg-white">
              <img src={TCSlogo} alt="TCS Logo" height="100px" width="100px" />
              <p className=" text-gray-800 font-medium mt-4">
                Full Stack Developer
              </p>
              <p className=" text-gray-500 text-sm">Aug 2021 - Present</p>
            </div>
          </section>
        </section>

        {/* Education */}
        <section id="education" className="w-5/6 mx-auto mb-14">
          <h2 className=" text-3xl text-teal-500 font-normal my-5 block">
            Education
          </h2>
          <section
            className="w-5/6 mx-auto cursor-pointer"
            onClick={() => window.open("https://www.annauniv.edu")}
          >
            <div className="bg-slate-100 lg:w-1/3 md:w-2/3 px-10 py-4 rounded-lg hover:bg-white">
              <img src={AnnaUnivLogo} alt="Anna University Logo" width="75px" />
              <p className=" text-gray-800 font-medium mt-4">
                BTech in Information Technology
              </p>
              <p className=" text-gray-500 text-sm">2017 - 2021</p>
            </div>
          </section>
        </section>

        {/* Projects */}
        <section id="projects" className="w-5/6 mx-auto mb-14">
          <h2 className=" text-3xl text-teal-500 font-normal my-5 block">
            Projects
          </h2>
          <section className="flex w-5/6 flex-wrap mx-auto gap-6">
            <div
              className="bg-slate-100 px-10 py-4 lg:w-1/4 md:w-2/3 w-full rounded-lg  hover:bg-white my-auto cursor-pointer"
              onClick={() =>
                window.open("https://github.com/gmnabeel/gmnabeel.github.io")
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className=" w-12"
              >
                <path d="M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z" />
              </svg>
              <p className=" text-gray-800 font-medium mt-3">Portfolio Site</p>
              <p className=" text-gray-500 text-sm">React, Tailwind</p>
            </div>
            <div
              className="bg-slate-100 px-10 py-4 lg:w-1/4 md:w-2/3 w-full rounded-lg  hover:bg-white my-auto cursor-pointer"
              onClick={() =>
                window.open("https://github.com/gmnabeel/Youtube2.0")
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className=" w-12"
              >
                <path d="M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z" />
              </svg>
              <p className=" text-gray-800 font-medium mt-3">Youtube 2.0</p>
              <p className=" text-gray-500 text-sm">React, mUI, Node JS</p>
            </div>
            <div
              className="bg-slate-100 px-10 py-4 lg:w-1/4 md:w-2/3 w-full rounded-lg  hover:bg-white my-auto cursor-pointer"
              onClick={() =>
                window.open(
                  "https://github.com/gmnabeel/Fake-News-Detection-SL"
                )
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                className="w-11"
              >
                <path d="M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z" />
              </svg>
              <p className=" text-gray-800 font-medium mt-3">
                Fake News Detection
              </p>
              <p className=" text-gray-500 text-sm">Python, ML</p>
            </div>
          </section>
        </section>

        {/* Contact Start  */}
        <section id="contact" className="w-5/6 mx-auto">
          <h2 className=" text-3xl text-teal-500 font-normal my-5 block">
            Contact
          </h2>
          <section className="w-5/6 mx-auto">
            <form
              method="POST"
              action="https://formspree.io/f/xknerznl"
              className=" [&>*]:mb-5"
            >
              <input
                type="hidden"
                name="_subject"
                value="Contact request from personal website"
                className="rounded-lg"
              />
              <input
                className="w-full md:w-4/6  p-4 rounded-lg text-sm text-gray-600 bg-gray-50 hover:bg-white hover:text-gray-800"
                type="email"
                name="_replyto"
                placeholder="Your email"
                required
              />
              <textarea
                className="w-full md:w-4/6 h-36 p-4 rounded-lg text-sm text-gray-600 bg-gray-50 hover:bg-white hover:text-gray-800"
                name="message"
                placeholder="Your message"
                required
              ></textarea>
              <button
                type="submit"
                className="w-full md:w-4/6 p-2 border-[1px] rounded-lg bg-white text-gray-900 hover:text-gray-50 hover:bg-teal-700"
              >
                Send
              </button>
            </form>
          </section>
        </section>
      </main>

      {/* Footer section */}
      <div className="mt-5 border-opacity-75 border-t-gray-200 border-t-[1px]">
        <footer className="flex flex-row justify-between text-gray-200 w-5/6 mx-auto py-7 align-top ">
          <span className="text-white text-md my-auto">
            &copy; {new Date().getFullYear()} - All Rights Reserved
          </span>
          <a href="#home" title="Top">
            <i className="fa fa-chevron-up text-gray-200 border-2 rounded-full px-3 py-2 border-gray-400 hover:text-gray-100 hover:border-gray-200"></i>
          </a>
          <section className="hidden lg:flex justify-center gap-10">
            <button
              title="Nabeel's Github"
              className="fa fa-github text-2xl"
              onClick={() => window.open("https://www.github.com/gmnabeel/")}
            ></button>
            <button
              title="Nabeel's Linkedin"
              className="fa fa-linkedin text-xl"
              onClick={() =>
                window.open("https://www.linkedin.com/in/gmnabeel/")
              }
            ></button>
            <button
              title="Nabeel's Stackoverflow"
              className="fa fa-brands fa-stack-overflow text-xl"
              onClick={() =>
                window.open(
                  "https://stackoverflow.com/users/10522121/nabeel-gm/"
                )
              }
            ></button>
          </section>
        </footer>
      </div>
    </>
  );
};

export default App;
